import React from 'react';
import { ShoppingCart } from '@material-ui/icons'
import { SidebarContainer, Icon, IconLeft, CloseIcon, SidebarWrapper, SidebarMenu, SidebarLink } from './style';
import { Link, useLocation } from 'react-router-dom';
import { IconButton, Badge } from '@material-ui/core';

const Sidebar = ({ isOpen, toggle, totalItems, refFooter, refAbout, refHome, refMetod }) => {

  

    function showFooter () {
        window.scrollTo({
          top: refFooter.current.offsetTop - 30,
          behavior: "smooth"
        })

      }
      function showAbout() {
        window.scrollTo({
          top: refAbout.current.offsetTop - 30,
          behavior: "smooth"
        })

      }

      function showHome() {
        window.scrollTo({
          top: refHome.current.offsetTop - 30,
          behavior: "smooth"
        })

      }

      function showMetod() {
        window.scrollTo({
          top: refMetod.current.offsetTop - 30,
          behavior: "smooth"
        })

      }

    const location = useLocation();

    return (
        <SidebarContainer isOpen={isOpen} onClick={toggle}>
            <IconLeft>
                        {location.pathname === '/' && (
                            <div>
                                <IconButton component={Link} to="/cart" color="inherit">
                                    <Badge badgeContent={totalItems} color="error">
                                        <ShoppingCart />
                                    </Badge>
                                </IconButton>
                            </div>
                        )}
            </IconLeft>
            <Icon onClick={toggle}>
                <CloseIcon/>
            </Icon>
            <SidebarWrapper>
                <SidebarMenu>
                    <SidebarLink onClick={() => showHome (toggle)}>
                        Beranda
                    </SidebarLink>
                    <SidebarLink onClick={() => showAbout (toggle)}>
                        Tentang Kami
                    </SidebarLink>
                    <SidebarLink onClick={() => showMetod (toggle)}>
                        Cara Pembelian
                    </SidebarLink>
                    <SidebarLink onClick={() => showFooter (toggle)}>
                        Kontak Kami
                    </SidebarLink>
                </SidebarMenu>
            </SidebarWrapper>
        </SidebarContainer>
    );
};

export default Sidebar;